import { ReceiptText } from "lucide-react";
import type { ModuleManifest } from "@/modules/module-registry";
import type { PermissionDefinition } from "@/modules/access";
import { invoicesDocumentKinds } from "./document-kinds";

// What Invoices lets staff grant. `invoices-app`: read: open the app. `invoices`: read: see invoices and credit notes and download them; write: create and edit drafts, record status changes. `invoices-issue`: write: give an invoice its number and freeze it (nothing can be edited afterwards). Opening needs the first two.
export const invoicesPermissions: readonly PermissionDefinition[] = [
  { resource: "invoices-app", label: "invoices-app.resource", levels: ["read"], ownable: false, staffOnly: true },
  { resource: "invoices", label: "invoices.resource", levels: ["read", "write"], ownable: false, staffOnly: true },
  { resource: "invoices-issue", label: "invoices-issue.resource", levels: ["write"], ownable: false, staffOnly: true },
];

/** The Invoices app declares itself: an optional app, off for new installs until an administrator switches it on in the App store. It needs Contacts (the customer is a contact). Any legal entity can issue; the entity is chosen on each invoice. */
export const invoicesManifest: ModuleManifest = {
  id: "invoices", href: "/invoices", icon: ReceiptText,
  name: "auth.modules.invoices", description: "settings.appStore.apps.invoices.description",
  permissionDefinitions: invoicesPermissions, permissions: ["invoices-app", "invoices", "invoices-issue"], appPermission: "invoices-app", needs: ["contacts"], contributes: [],
  optional: true, documentKinds: invoicesDocumentKinds,
};
